import i18n from "i18next";

class DateFormatter {
    formatDate (value?: string | number | Date) {
        const date = this.toDate(value);
        return date ? date.toLocaleDateString(i18n.language, {dateStyle: "medium"}) : "";
    }

    formatDateTime (value?: string | number | Date) {
        const date = this.toDate(value);
        return date ? date.toLocaleString(i18n.language, {dateStyle: "medium", timeStyle: "short"}) : "";
    }

    /** Numeric date for list columns (de: 08.10.2026, en: 10/08/2026); `language` defaults to the active one. */
    formatShortDate (value?: string | number | Date, language: string = i18n.language) {
        const date = this.toDate(value);
        return date ? date.toLocaleDateString(language, {day: "2-digit", month: "2-digit", year: "numeric"}) : "";
    }

    private toDate (value?: string | number | Date) {
        if (value === undefined || value === null || value === "") {
            return undefined;
        }
        const date = value instanceof Date ? value : new Date(value);
        return isNaN(date.getTime()) ? undefined : date;
    }
}

export default new DateFormatter();
